import { useEffect } from 'react';

import classNames from 'classnames';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import { DialogContent } from '../../../components/Dialog/DialogContent';
import { DialogHeader } from '../../../components/Dialog/DialogHeader';
import type { WizardChildProps } from '../../../components/Wizard/types';
import { CONTACT_SUPPORT_URL } from '../../../config/constants';
import { analytics } from '../../../services/analytics';
import { useStores } from '../../../stores/useStores';

import styles from './PasswordResetSuccess.module.scss';

export const ResetPasswordSuccess = observer((props: WizardChildProps) => {
  const { t } = useTranslation();
  const { authStore, portalStore } = useStores();

  const landingKey = authStore.getLandingKey();

  useEffect(() => {
    if (props.isCurrent) {
      void analytics.sendEvent('log_in', {
        step_name: 'password_reset_email_sent',
        event_action: 'impression',
        triggered_by: 'reset_password',
        landingKey,
      });
    }
  }, [props.isCurrent, landingKey]);

  return (
    <>
      <DialogHeader
        closeBtnDataTestId="reset-password-success-close-btn"
        title={t('auth.resetPassword')}
        onClose={portalStore.closePortal}
        onGoBack={props.prevStep}
      />

      <DialogContent>
        <h4 className={styles.subTitle}>{t('auth.passwordResetEmailSent')}</h4>
        <p>{t('auth.checkSpamOrContactSupport')}</p>
        <div className={styles.contactSupportButtonWrapper}>
          <a
            className={classNames('button-action', styles.contactSupportButton, 'support-button')}
            href={CONTACT_SUPPORT_URL}
            rel="noreferrer"
            target="_blank"
          >
            {t('common.contactSupport')}
          </a>
        </div>
      </DialogContent>
    </>
  );
});
